export default __webpack_public_path__ + "static/media/trycycle.3f1171b1.png";